import { SettingsLayoutContainer } from "@/features/settings-layout/containers/settings-layout-container";
import { beforeAuthGuard } from "@/features/auth/guards";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/organisation")({
  beforeLoad: beforeAuthGuard,
  component: SettingsLayoutContainer,
});
